module.exports = __webpack_public_path__ + "static/assets/a3e478fafe815bf1c17db647817db395.svg";